import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Descriptions } from "antd";
import "./applicationDetail.scss";
import ApplicationDetailTemplate from "../../../components/applicationDetailTemplate/applicationDetailTemplate";
import { applicationDetail, paymentGet } from "../../../apis/admin";
import { previewToValue } from "../../../components/mapToTemplate";
import { replaceUrlByParams } from "../../../utils/api";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";
import { PAGE, TIME_FORMAT } from "../../../utils/constants";
import { AppContext } from "../../../App";
import PaymentStatusTemplate from "../../../components/paymentStatusTemplate/paymentStatusTemplate";

function AdminApplicationDetailPage() {
	let history = useHistory();
	const { pid, id } = useParams();
	const [data, setData] = useState({
		sections: [],
	});
	const [paymentData, setPaymentData] = useState({});

	const { setLoading } = useContext(AppContext);

	useEffect(() => {
		getPaymentDetail();

		getApplicationDetail();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getApplicationDetail = async () => {
		setLoading(true);
		try {
			const res = await applicationDetail(pid, id);
			if (res.error) {
				throw new Error(`${res.error.msgCode} - ${res.error.message}`);
			} else {
				setData({
					...data,
					applicationNumber: res.applicationNumber,
					applicationTimestamp: res.applicationTimestamp,
					sections: res.sections,
				});
			}
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};
	const getPaymentDetail = async () => {
		setLoading(true);
		try {
			const res = await paymentGet(pid, id);
			if (res.error) {
				throw new Error(`${res.error.msgCode} - ${res.error.message}`);
			} else {
				setPaymentData(res);
			}
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	function onEdit() {
		const formValue = previewToValue(data.sections);
		console.log(formValue);
		history.push({
			pathname: `${replaceUrlByParams(PAGE.ADMIN_APPLICATION_EDIT, {
				":pid": pid,
				":id": id,
			})}`,
			state: { formValue: formValue },
		});
	}

	return (
		<div className="application-detail-page">
			<div className="header-section">
				<Descriptions title="申請狀況">
					<Descriptions.Item label="申請編號">
						{data.applicationNumber}
					</Descriptions.Item>
					<Descriptions.Item label="申請遞交時間">
						{moment(data.applicationTimestamp).format(TIME_FORMAT)}
					</Descriptions.Item>
				</Descriptions>

				<a onClick={onEdit}>
					<EditOutlined /> 編輯表格
				</a>
			</div>

			<PaymentStatusTemplate
				pid={pid}
				id={id}
				canEdit={true}
				paymentData={paymentData}
			/>
			<ApplicationDetailTemplate sections={data.sections} />
		</div>
	);
}

export default AdminApplicationDetailPage;
